var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "contents",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:red;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "\u30A2\u30FC\u30C8\u30DC\u30FC\u30C9 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 75,
    height: 75,
    rx: 11.338583,
    id: "rect8",
    x: 0,
    y: 0,
    ry: 11.338583,
    style: {
      fill: "#00ff00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "surface146261",
    transform: "matrix(0.07017544,0,0,0.06488459,9.429824,11.546164)",
    style: {
      strokeWidth: 19.7594
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211714",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 19.7594
    },
    d: "M 311.91406,340.89844 C 294.61719,340.90234 280,360.09766 280,382.82031 c 0,22.72266 14.61719,41.92188 31.91406,41.92188 17.29688,0 31.91406,-19.19922 31.91406,-41.92578 0,-22.71875 -14.61718,-41.91797 -31.91406,-41.91797",
    id: "path834"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211714",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 19.7594
    },
    d: "m 509.39062,460.98047 -36.32031,-58.53125 -8.19531,9.58594 v 48.94531 H 423.28125 V 304.65625 H 464.875 v 47.69141 l 41.24219,-47.69141 h 50.51953 l -55.58203,65.04687 58.17968,91.27735 z m -197.47656,0.28515 c -39.23047,-0.008 -71.14453,-35.19921 -71.14844,-78.44921 0.004,-43.25 31.92188,-78.4375 71.15235,-78.4375 39.23047,0 71.14844,35.1914 71.15234,78.4414 0,43.25391 -31.92187,78.44141 -71.15625,78.44531 m 262.65625,90.71094 C 641.75391,512.82812 685,451.62109 685,382.82031 c 0,-118.1875 -127.59766,-214 -285,-214 -157.40234,0 -285,95.8125 -285,214 0,118.1875 127.59766,214 285,214 24.07812,0 47.45312,-2.25 69.78516,-6.47265 30.42578,25.48437 69.6289,40.83203 112.42187,40.83203 24.68359,0 48.16797,-5.11719 69.46875,-14.32422 -31.61328,-13.67188 -58.39844,-36.38672 -77.10547,-64.87891",
    id: "path836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestOk);
export default __webpack_public_path__ + "static/media/TestOk.a26078ffe0f779edfa8c2225277c7ccd.svg";
export { ForwardRef as ReactComponent };